import { createContext, useContext } from 'react'
import AppStore from './AppStore'
import type MapStore from './MapStore'
import type MonitorStore from './MonitorStore'
import { type RouterStore } from 'mobx-react-router'
import type UserStore from './UserStore'
import type LayerStore from './LayerStore'
import type ViewStore from './ViewStore'
import type DashboardStore from './DashboardStore'
import type FilterStore from './FilterStore'

const appStore = new AppStore()

interface Stores {
  map: MapStore
  monitor: MonitorStore
  routing: RouterStore
  app: AppStore
  user: UserStore
  project: AppStore
  layers: LayerStore
  view: ViewStore
  filter: FilterStore
  dashboard: DashboardStore
}

export const StoreContext = createContext(appStore)

export const useStore = (): Stores => {
  const appStore = useContext(StoreContext)
  return {
    map: appStore.mapStore,
    monitor: appStore.monitorStore,
    routing: appStore.routingStore,
    app: appStore,
    user: appStore.userStore,
    project: appStore,
    layers: appStore.layerStore,
    view: appStore.viewStore,
    filter: appStore.filterStore,
    dashboard: appStore.dashboardStore
  }
}

export default appStore
